import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_download.svg';
import Icon, { IconProps } from './icon';

const IconDownload = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconDownload;
